import { Alert } from "antd";
import { FINAL_STATUSES, REASON_LABEL, STATUS_LABEL } from "features/ConsultRequest/core/constants";
import { formatDateTime } from "features/ConsultRequest/core/utils";

const anyPermission = (p = {}) =>
  p.canAssign || p.canReassign || p.canAddNote || p.canUploadFile || (p.allowedTransitions || []).length > 0;

export default function ReadonlyBanner({ detail }) {
  if (FINAL_STATUSES.includes(detail.status)) {
    const parts = [
      `🔒 Phiếu đã khóa · ${STATUS_LABEL[detail.status]} lúc ${formatDateTime(detail.closedAt)}`,
      detail.closedBy?.name && `bởi ${detail.closedBy.name}`,
      detail.closeReasonCode && `Lý do: ${REASON_LABEL[detail.closeReasonCode] || detail.closeReasonCode}`,
      detail.closeReasonNote && `Ghi chú: ${detail.closeReasonNote}`,
    ].filter(Boolean);
    return <Alert type="info" message={parts.join(" · ")} />;
  }
  if (!anyPermission(detail.permissions)) {
    const owner = detail.assignee?.name ? `Phiếu do ${detail.assignee.name} phụ trách` : "Phiếu chưa được phân công";
    return <Alert type="warning" message={`Bạn chỉ xem được phiếu này. ${owner}`} />;
  }
  return null;
}
